import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { extendTheme } from "@mui/joy/styles"
import { purple } from "@mui/material/colors";

const container = document.getElementById('root')!;
const root = createRoot(container);


const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: "#FF5733"
    },
    background: {
      default: "#000F36",
      paper: "#1d2435",
    },
    text: {
      primary:"#fff",
    },
    secondary: purple,
  },
  components: {
    MuiChip: {
      
    }
  }
})

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={ theme }>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
